import InputField from 'components/fields/InputField';
import { markOrderProductAsPrepared } from 'interfaces/delivery';
import { bulkEditOrderLotNumber } from 'interfaces/order';
import { useEffect, useState } from 'react';
import { MdCheckCircle } from 'react-icons/md';
import { getTotalHT } from 'views/orders/createOrders/utils';
import StartProductionModal from './StartProduction';
import { useDisclosure } from '@chakra-ui/hooks';
import ProductionPreviewModal from 'views/production/viewProductions/components/ProductionPreview';
import { dateToFrenchShort } from 'utils/date';

const ItemsTable = (props: {
    items: any;
    handleQtyChange: any;
    handlePriceChange: any;
    handleDiscountTypeChange: any;
    handleDiscountChange: any;
    handleCommentChange: any;
    setSaveStatus: any;
    onDelete: any;
    filter: string;
    defaultItems: any;
    products: any;
}) => {
    const { items, setSaveStatus, filter, defaultItems, products } = props;

    const [refreshableitems, setRefreshableitems] = useState<any>(items);
    const [lotNumberItems, setLotNumberItems] = useState<any>([]);

    const [selectedProduct, setSelectedProduct] = useState<any>([]);
    const [selectedProduction, setSelectedProduction] = useState<any>({
        date: new Date().toISOString().split('T')[0],
        quantity: 1,
        area: 'zone-a',
        lotNumber: '',
        comment: ' ',
        product: '',
        type: '',
    });
    const [selectedLotNumber, setSelectedLotNumber] = useState<any>(null);

    const { isOpen, onOpen, onClose } = useDisclosure();
    const {
        isOpen: isOpenProduction,
        onOpen: onOpenProduction,
        onClose: onCloseProduction,
    } = useDisclosure();

    const handleLotNumberChange = (item: any, value: any) => {
        const items = [...lotNumberItems];
        for (let i = 0; i < item.orderIds.length; i++) {
            if (
                items.find(
                    (x: any) =>
                        x.index === `${item.productId}-${item.orderIds[i]}`,
                )
            ) {
                items.find(
                    (x: any) =>
                        x.index === `${item.productId}-${item.orderIds[i]}`,
                ).lotNumber = value;
            } else {
                items.push({
                    productId: item.productId,
                    lotNumber: value,
                    orderId: item.orderIds[i],
                    index: `${item.productId}-${item.orderIds[i]}`,
                });
            }
        }
        setLotNumberItems(items);
        const newItems = [...refreshableitems];
        newItems.map((x: any) => {
            if (x.productId === item.productId) {
                x.lotNumber = value;
            }
        });
        setRefreshableitems(newItems);
    };

    const displayOrderList = (item: any, value: any) => {
        const items = [...refreshableitems];

        const itemToDisplay: any = items.find(
            (x: any) => x.productId === item._id,
        );

        if (itemToDisplay) {
            items.find((x: any) => x.productId === item.productId).display =
                value;
        }
        setRefreshableitems([...refreshableitems]);
    };

    useEffect(() => {
        setSaveStatus('saving');
        const delayDebounceFn = setTimeout(async () => {
            const res = await bulkEditOrderLotNumber(lotNumberItems);
            if (res) setSaveStatus('saved');
            else setSaveStatus('error');
        }, 2000);
        return () => clearTimeout(delayDebounceFn);
    }, [lotNumberItems]);

    const getDefaultLotNumber = (id: string) => {
        const item = defaultItems.find((x: any) => x._id === id);
        if (item) return item.defaultLotNumber;
        return null;
    };

    const countNumberOfDisplayedItems = () => {
        let count = 0;
        refreshableitems.map((item: any) => {
            if (
                filter === 'all' ||
                (filter === 'to-prepare' && totalToPrepare(item) > 0) ||
                (filter === 'prepared' && totalToPrepare(item) === 0) ||
                (getDefaultLotNumber(item._id) && filter === 'associated') ||
                (!getDefaultLotNumber(item._id) && filter === 'not-associated')
            ) {
                count++;
            }
        });
        return count;
    };

    const totalToPrepare = (item: any) => {
        let quantities = item.quantities;

        let total = 0;
        for (let i = 0; i < item.isItemPrepared.length; i++) {
            if (!item.isItemPrepared[i]) {
                total += quantities[i];
            }
        }
        return total;
    };

    useEffect(() => {
        setRefreshableitems(items);
    }, [items]);

    const getTagColor = (row: any) => {
        if (row?.productTag && typeof row.productTag === 'object' && row.productTag.color)
            return row.productTag.color;

        const prod =
            products?.find((p: any) => p._id === row._id || p._id === row.productId) || null;

        if (prod?.productTag && typeof prod.productTag === 'object' && prod.productTag.color)
            return prod.productTag.color;

        return null;
    };

    return (
        <>
            <ProductionPreviewModal
                isOpen={isOpenProduction}
                onClose={onCloseProduction}
                product={selectedProduction}
                productName={selectedProduct ? selectedProduct.name : ''}
                onProduction={onCloseProduction}
            />
            <StartProductionModal
                isOpen={isOpen}
                onClose={onClose}
                products={selectedProduct ? [selectedProduct] : products}
                lotNumber={selectedLotNumber}
                productName={'Test'}
                onProduction={(production: any) => {
                    setSelectedProduction(production);
                    onClose();
                    onOpenProduction();
                }}
            />
            {countNumberOfDisplayedItems() === 0 ? (
                <div className="col-span-12 mt-10 mb-10">
                    <h4 className="col-span-12 my-auto mt-3 text-center text-2xl font-medium text-navy-700 dark:text-white">
                        Aucun produit trouvé
                    </h4>
                    <p className="col-span-12 my-auto mt-3 text-center text-base text-navy-700 dark:text-white">
                        {filter === 'all' &&
                            "Vous pouvez parcourir d'autres dates"}
                        {filter === 'associated' &&
                            "Aucun produit avec numéro de lot associé n'a été trouvé"}
                        {filter === 'not-associated' &&
                            "Aucun produit avec numéro de lot non associé n'a été trouvé"}
                        {filter === 'to-prepare' &&
                            "Aucun produit à préparer n'a été trouvé"}
                        {filter === 'prepared' &&
                            "Aucun produit préparé n'a été trouvé"}
                    </p>
                </div>
            ) : (
                <div className="my-3 rounded-lg border border-r">
                    <div className="relative overflow-x-auto">
                        <table className="w-full text-sm text-left rtl:text-right text-gray-500">
                            <thead className="text-gray-700 bg-gray-50">
                                <tr>
                                    <th scope="col" className="px-2 py-3">
                                        Produit
                                    </th>
                                    <th scope="col" className="px-2 py-3">
                                        Stock
                                    </th>
                                    <th scope="col" className="px-2 py-3">
                                        Commandé
                                    </th>
                                    <th scope="col" className="px-2 py-3">
                                        Conseils de production
                                    </th>
                                    <th scope="col" className="px-2 py-3">
                                        À préparer
                                    </th>
                                    <th scope="col" className="px-2 py-3">
                                        N de lot
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {refreshableitems
                                    .sort((a: any, b: any) =>
                                        a.name.localeCompare(b.name),
                                    )
                                    .map((item: any, index: number) => (
                                        <>
                                            {filter === 'all' ||
                                            (filter === 'to-prepare' &&
                                                totalToPrepare(item) > 0) ||
                                            (filter === 'prepared' &&
                                                totalToPrepare(item) === 0) ||
                                            (getDefaultLotNumber(item._id) &&
                                                filter === 'associated') ||
                                            (!getDefaultLotNumber(item._id) &&
                                                filter === 'not-associated') ? (
                                                <>
                                                    {/* Main entity */}
                                                    <tr
                                                        className="bg-white border-b text-gray-800 border-gray-200 hover:bg-gray-100 cursor-pointer"
                                                        onClick={() => {}}
                                                    >
                                                        {/* Product / quantities */}
                                                        <td
                                                          className={`px-2 py-3 ${getTagColor(item) ? 'border-l-8' : ''}`}
                                                          style={getTagColor(item) ? { borderLeftColor: getTagColor(item) } : undefined}
                                                        >
                                                                {getTagColor(item) && (
                                                                  <span
                                                                    className="w-3 h-3 rounded-full border border-white shadow-sm items-center justify-center flex mt-[2px]"
                                                                    style={{ backgroundColor: getTagColor(item) }}
                                                                  />
                                                                )}
                                                                    {item.ref}{' '}
                                                                
                                                                {'  '}
                                                                {item.name}
                                                                {item.productTag?.color}
                                                            
                                                            <div className="flex my-auto gap-2">
                                                                {totalToPrepare(
                                                                    item,
                                                                ) === 0 && (
                                                                    <MdCheckCircle className="flex my-auto text-green-500" />
                                                                )}
                                                                <p className="text-xs text-gray-700">
                                                                    {
                                                                        item
                                                                            .deliveryDates
                                                                            .length
                                                                    }
                                                                    {
                                                                        ' dates de livraison'
                                                                    }
                                                                    {' - '}
                                                                    {`${
                                                                        item
                                                                            .orderIds
                                                                            .length
                                                                    } ${
                                                                        item
                                                                            .orderIds
                                                                            .length >
                                                                        1
                                                                            ? 'commandes'
                                                                            : 'commande'
                                                                    } avec ce produit`}
                                                                </p>
                                                            </div>
                                                            <div className="mt-1">
                                                                {!item.display ? (
                                                                    <button
                                                                        onClick={() =>
                                                                            displayOrderList(
                                                                                item,
                                                                                true,
                                                                            )
                                                                        }
                                                                        className="text-blue-500"
                                                                    >
                                                                        {'+'}{' '}
                                                                        Voir les
                                                                        commandes
                                                                    </button>
                                                                ) : (
                                                                    <button
                                                                        onClick={() =>
                                                                            displayOrderList(
                                                                                item,
                                                                                false,
                                                                            )
                                                                        }
                                                                        className="mt-2 text-blue-500"
                                                                    >
                                                                        {'-'}{' '}
                                                                        Masquer
                                                                        les
                                                                        commandes
                                                                    </button>
                                                                )}
                                                            </div>
                                                        </td>
                                                        {/* Stock */}
                                                        <td className="px-2 max-w-[180px] py-3">
                                                            {products
                                                                ?.find(
                                                                    (x: any) =>
                                                                        x._id ===
                                                                        item._id,
                                                                )
                                                                ?.quantity.toFixed(
                                                                    2,
                                                                )}{' '}
                                                            {item.unity}
                                                        </td>
                                                        {/* Ordered */}
                                                        <td className="px-2 py-3">
                                                            {item.quantity?.toFixed(
                                                                2,
                                                            )}{' '}
                                                            {item.unity}
                                                        </td>
                                                        {/* Advices */}
                                                        <td className="px-2 py-3">
                                                            {item?.quantity -
                                                                products
                                                                    ?.find(
                                                                        (
                                                                            x: any,
                                                                        ) =>
                                                                            x._id ===
                                                                            item._id,
                                                                    )
                                                                    ?.quantity?.toFixed(
                                                                        2,
                                                                    ) >
                                                            0
                                                                ? item?.quantity -
                                                                  products
                                                                      ?.find(
                                                                          (
                                                                              x: any,
                                                                          ) =>
                                                                              x._id ===
                                                                              item._id,
                                                                      )
                                                                      ?.quantity?.toFixed(
                                                                          2,
                                                                      )
                                                                : 0}{' '}
                                                            {item.unity}
                                                        </td>
                                                        {/* To prepare */}
                                                        <td className="px-2 py-3">
                                                            {totalToPrepare(
                                                                item,
                                                            )?.toFixed(2)}{' '}
                                                            {item.unity}
                                                        </td>
                                                        {/* Lot number */}
                                                        <td className="px-2 py-3">
                                                            <div className="gap-[5px] items-center">
                                                                <InputField
                                                                    key={`${item.name}-${index}-ln`}
                                                                    extra="w-[140px]"
                                                                    placeholder="10403997"
                                                                    id={
                                                                        'lotNumber'
                                                                    }
                                                                    type="text"
                                                                    value={
                                                                        item.lotNumber
                                                                    }
                                                                    onChange={(
                                                                        e: any,
                                                                    ) =>
                                                                        handleLotNumberChange(
                                                                            item,
                                                                            e
                                                                                .target
                                                                                .value,
                                                                        )
                                                                    }
                                                                    inputSmall={
                                                                        true
                                                                    }
                                                                    disabled={
                                                                        false
                                                                    }
                                                                />
                                                                {item.lotNumber && (
                                                                    <p
                                                                        className="text-[11px] text-toola-500 hover:cursor-pointer"
                                                                        onClick={async () => {
                                                                            setSelectedProduct(
                                                                                products.find(
                                                                                    (
                                                                                        x: any,
                                                                                    ) =>
                                                                                        x._id ===
                                                                                        item.productId,
                                                                                ),
                                                                            );
                                                                            setSelectedLotNumber(
                                                                                item.lotNumber,
                                                                            );
                                                                            onOpen();
                                                                        }}
                                                                    >
                                                                        Lancer
                                                                        la
                                                                        production{' '}
                                                                        {
                                                                            item.lotNumber
                                                                        }
                                                                    </p>
                                                                )}
                                                            </div>
                                                        </td>
                                                    </tr>

                                                    {/* Sub entities */}
                                                    {item.display &&
                                                        item.companies.map(
                                                            (
                                                                company: any,
                                                                index: number,
                                                            ) => (
                                                                <>
                                                                    <tr
                                                                        className="bg-gray-50 border-b text-gray-800 border-gray-200 hover:bg-gray-100"
                                                                        onClick={() => {}}
                                                                    >
                                                                        <td
                                                                          className={`p-2 ${getTagColor(item) ? 'border-l-8' : ''}`}
                                                                          style={getTagColor(item) ? { borderLeftColor: getTagColor(item) } : undefined}
                                                                        >
                                                                            <a
                                                                                href={`/order/${item.orderIds[index]}`}
                                                                                target="_blank"
                                                                                rel="noreferrer"
                                                                                className={`${
                                                                                    item
                                                                                        .isItemPrepared[
                                                                                        index
                                                                                    ]
                                                                                        ? 'text-green-600'
                                                                                        : 'text-red-400'
                                                                                } text-[13px]`}
                                                                            >
                                                                                {
                                                                                    '>'
                                                                                }{' '}
                                                                                {
                                                                                    company
                                                                                }{' '}
                                                                                (
                                                                                {
                                                                                    item
                                                                                        .quantities[
                                                                                        index
                                                                                    ]
                                                                                }

                                                                                ){' '}
                                                                            </a>
                                                                        </td>
                                                                        <td className="">
                                                                            {!item
                                                                                .isItemPrepared[
                                                                                index
                                                                            ] ? (
                                                                                <p
                                                                                    className="flex underline my-auto ml-3 text-toola-500 text-xs hover:cursor-pointer"
                                                                                    onClick={async () => {
                                                                                        await markOrderProductAsPrepared(
                                                                                            item
                                                                                                .orderIds[
                                                                                                index
                                                                                            ],
                                                                                            item.productId,
                                                                                        );
                                                                                        setRefreshableitems(
                                                                                            (
                                                                                                prevItems: any,
                                                                                            ) => {
                                                                                                const newItems =
                                                                                                    [
                                                                                                        ...prevItems,
                                                                                                    ];
                                                                                                newItems.map(
                                                                                                    (
                                                                                                        x: any,
                                                                                                    ) => {
                                                                                                        if (
                                                                                                            x.productId ===
                                                                                                            item.productId
                                                                                                        ) {
                                                                                                            x.isItemPrepared[
                                                                                                                index
                                                                                                            ] =
                                                                                                                true;
                                                                                                        }
                                                                                                    },
                                                                                                );
                                                                                                return newItems;
                                                                                            },
                                                                                        );
                                                                                    }}
                                                                                >
                                                                                    Préparer
                                                                                </p>
                                                                            ) : (
                                                                                <p className="flex my-auto ml-3 font-bold text-xs text-green-600">
                                                                                    Préparé
                                                                                </p>
                                                                            )}
                                                                        </td>
                                                                        <td
                                                                            className="p-2"
                                                                            colSpan={
                                                                                4
                                                                            }
                                                                        >
                                                                            <p className="text-xs">
                                                                                <span className="underline">
                                                                                    Commentaire:
                                                                                </span>{' '}
                                                                                {
                                                                                    item
                                                                                        ?.comment[
                                                                                        index
                                                                                    ]
                                                                                }
                                                                            </p>
                                                                        </td>
                                                                    </tr>
                                                                </>
                                                            ),
                                                        )}
                                                </>
                                            ) : null}
                                        </>
                                    ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            )}
        </>
    );
};

export default ItemsTable;
